import React, {
  ReactElement, useCallback, useEffect,
} from 'react';
import { SearchInputButton } from 'slovlex-idsk-react-components';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';

interface Props {
  filterCopy: PrispevokVestnikaListFilter;
  label?: string;
  filterSearchText: string;
  fieldName: keyof PrispevokVestnikaListFilter;
  onUpdateFieldCopy: SafeParameterSetter<PrispevokVestnikaListFilter>;
  setFilter: (filter) => void;
  className?: string;
  type?: 'search' | 'search-number';
  maxLength?: number;
}

const SearchInput = ({
  filterCopy,
  label,
  filterSearchText,
  setFilter,
  onUpdateFieldCopy,
  fieldName,
  className,
  type = 'search',
  maxLength,
}: Props): ReactElement => {
  const onSubmit = useCallback(async (): Promise<void> => {
    setFilter(filterCopy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterCopy)]);

  useEffect(() => {
    const keyDownHandler = async (e): Promise<void> => {
      if (e.key === 'Enter') {
        e.preventDefault();
        await onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onSubmit]);

  return (
    <SearchInputButton
      className={className}
      label={label}
      searchText={filterSearchText}
      setSearchText={(value: string) => onUpdateFieldCopy(fieldName, value)}
      onClearSearch={() => {
        onUpdateFieldCopy(fieldName, '');
      }}
      onButtonSubmit={onSubmit}
      type={type}
      maxLength={maxLength}
    />
  );
};

export default SearchInput;
